if(!window.SwymCallbacks){window.SwymCallbacks = [];}
window.SwymCallbacks.push(function(){
  _swat.fetchWrtEventTypeET(function(products){
     wishlistRender(products);
  }, _swat.EventTypes.addToWishlist);
});

  wishlistRender = function(products) {
  $(document).ready(function() {
    var template = $('[data-wishlist-template]');
    var empty_template = $('[data-wishlist-empty]');
    var content = $('#wishlist-content');

    if (!products || products.length < 1) {
      empty_template.show();
      return;
    }

    products.forEach(function(p) {
      var row = template.clone();
      
      row.removeClass('hidden');
      row.find('[data-name]').html(p.dt);
      row.find('[data-url]').attr('href', p.du);
      row.find('[data-image]').attr('src', p.iu);
      row.find('[data-price]').html(p.pr + window.CURRENCY);

      row.find('[data-remove]').on('click', function(e) {
        e.preventDefault();
        console.log(p._id);
        _swat.removeFromWishList(p, function callback() {
          row.remove();
          window.loadWishlistBubble();
        });
      });

      content.append(row);
    });
  });
 }